var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_76","data-name":"Ellipse 76","cx":"20","cy":"20","r":"20","fill":"#a1daf8","key":0}),React.createElement("path",{"id":"Icon_awesome-facebook-f","data-name":"Icon awesome-facebook-f","d":"M17.168,17.486l.863-5.626h-5.4V8.209c0-1.539.754-3.039,3.172-3.039h2.454V.38A29.928,29.928,0,0,0,13.9,0C9.457,0,6.551,2.695,6.551,7.573V11.86H1.609v5.626H6.551V30.853h6.082V17.486Z","transform":"translate(10.066 8.607)","fill":"#1d1d1d","key":1})]);
}

SocialFacebook.defaultProps = {"id":"facebook","width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
